/**
 * Flight alert texts: the words a customer agrees to, shared by the checkout
 * box, the trip page switch and the server that records the consent
 * (server/flight-status-sms.js). Carriers ask what the customer saw when
 * they opted in, so the server stores this exact text with each consent, and
 * changing it changes what new consents record.
 *
 * What the disclosure must carry (CTIA): who is texting, what about, that
 * frequency varies, that message and data rates may apply, and how to stop
 * (STOP) and get help (HELP), plus where the terms are.
 */
export const FLIGHT_ALERT_TEXTS_LABEL = 'Text me flight alerts';

/** The disclosure, before the links to the Terms and the Privacy Policy. */
export const FLIGHT_ALERT_TEXTS_DISCLOSURE =
  'Defera will text this number about your flights: delays, schedule changes, cancellations and diversions. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help.';

/** Everything the customer reads, as the consent records it. */
export const FLIGHT_ALERT_TEXTS_CONSENT = `${FLIGHT_ALERT_TEXTS_DISCLOSURE} See our Terms and Privacy Policy.`;

/** True when a phone has enough digits to text (10 for US/Canada, or + and a country code). */
export function textablePhone(phone) {
  const s = String(phone || '').trim();
  const digits = s.replace(/\D/g, '');
  return s.startsWith('+') ? digits.length >= 8 && digits.length <= 15 : digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
}

/** Where the disclosure's "Terms" points: the SMS section of the Terms of Service. */
export const FLIGHT_ALERT_TEXTS_TERMS_PATH = '/terms#text-messages';
